const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20red%20carpet%20event%20with%20golden%20spotlights%2C%20dramatic%20cinematic%20lighting%2C%20elegant%20venue%20entrance%2C%20paparazzi%20camera%20flashes%2C%20glamorous%20atmosphere%2C%20entertainment%20industry%20event%2C%20warm%20golden%20and%20crimson%20tones&width=1200&height=600&seq=carousel-chigua-01&orientation=landscape',
    title: '2026上半年娱乐圈大事件回顾',
    desc: '从顶流塌房到世纪复合，从综艺翻车到红毯封神，上半年最值得铭记的30个八卦名场面一次看够。',
    tag: '专题回顾',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Summer%20music%20festival%20concert%20crowd%20with%20colorful%20stage%20lights%2C%20energetic%20atmosphere%2C%20outdoor%20event%20at%20sunset%2C%20massive%20audience%2C%20live%20performance%2C%20vibrant%20neon%20colors%2C%20festival%20vibes&width=1200&height=600&seq=carousel-chigua-02&orientation=landscape',
    title: '暑期档综艺大战：谁是最强话题王',
    desc: '暑期档五大S+级综艺正面交锋，从导师阵容到选手争议再到赛制翻车，全方位吃瓜对比分析。',
    tag: '综艺专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fashion%20week%20backstage%20with%20designers%20and%20models%2C%20luxury%20dresses%20on%20racks%2C%20makeup%20artists%20working%2C%20glamorous%20behind%20the%20scenes%2C%20warm%20lighting%2C%20fashion%20industry%20atmosphere%2C%20elegant%20and%20busy&width=1200&height=600&seq=carousel-chigua-03&orientation=landscape',
    title: '国际时装周中国面孔全记录',
    desc: '本季四大时装周上中国艺人的完整表现，从看秀造型到后台花絮，谁在国际舞台上赢麻了？',
    tag: '时尚专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20award%20ceremony%20stage%20with%20golden%20trophy%2C%20spotlight%20on%20winner%2C%20audience%20applauding%2C%20dramatic%20cinematic%20moment%2C%20prestigious%20venue%2C%20warm%20golden%20lighting%2C%20celebration%20atmosphere&width=1200&height=600&seq=carousel-chigua-04&orientation=landscape',
    title: '颁奖季最全获奖名单与幕后揭秘',
    desc: '金鸡、百花、华表三大奖项完整获奖名单及评审内幕，那些奖杯背后不为人知的故事。',
    tag: '影视专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20smartphone%20screen%20with%20viral%20posts%2C%20trending%20hashtags%20floating%2C%20digital%20social%20network%20concept%2C%20warm%20gradient%20background%2C%20modern%20technology%2C%20online%20buzz%20and%20engagement&width=1200&height=600&seq=carousel-chigua-05&orientation=landscape',
    title: '微博之夜名场面大盘点',
    desc: '一年一度的微博之夜从来不缺话题，从座位安排暗藏玄机到红毯互动意味深长，全角度深度解读。',
    tag: '年度盘点',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20silhouette%20of%20person%20behind%20frosted%20glass%2C%20dramatic%20shadow%20and%20light%20play%2C%20investigative%20journalism%20vibe%2C%20dark%20and%20warm%20atmosphere%2C%20file%20folders%20and%20camera%2C%20entertainment%20industry%20insider%20theme&width=1200&height=600&seq=carousel-chigua-06&orientation=landscape',
    title: '娱乐圈未解之谜：那些悬而未决的大瓜',
    desc: '从隐婚疑云到代孕传闻，从合约罗生门到失踪艺人，那些至今没有定论的娱乐圈悬案全梳理。',
    tag: '深度调查',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
              焦点专题
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-foreground-600 text-sm max-w-lg mx-auto">
              深度策划的娱乐八卦专题内容，带你全方位吃透每一个大瓜
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {carouselItems.map((item) => (
              <div
                key={item.title}
                className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 overflow-hidden transition-all duration-200 cursor-pointer"
              >
                <div className="relative overflow-hidden aspect-[2/1]">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                    loading="lazy"
                    onError={(e) => {
                      (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                    }}
                  />
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 rounded-full bg-accent-500 text-white text-xs font-semibold">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-5 md:p-6 flex-1 flex flex-col">
                  <h3 className="font-heading font-bold text-base md:text-lg text-foreground-900 mb-3 group-hover:text-accent-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed flex-1">
                    {item.desc}
                  </p>
                  <div className="mt-4 pt-4 border-t border-background-200 flex items-center text-accent-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                    查看专题 <i className="ri-arrow-right-line ml-1"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}